module.exports = { 
	'github_profile':['swats117','prikevs'],
	'primary_user':'swats117',
	'session_password':"",
	'github_api':'https://api.github.com/users/',
	'tab_bar_height':50,
	'token':"6be83e7d2eed97b1b2d334b2416c3445996d8c93",
	'freqFinder':"",
}